
import useAppState from '../../context/AppContext';
import RecapElement from './RecapElement';
import { useNavigate } from 'react-router-dom';
import { isConfirmedContactProposition, isPropositionInDraft } from '../../utils/dataUtils';
import ButtonModifyRecapInfo from '../common/ButtonModifyRecapInfo';

interface RecapInfoBancaireFormComponentProps {
    modifyUrl : string
}

export default function RecapInfoBancaireFormComponent( {modifyUrl} : Readonly<RecapInfoBancaireFormComponentProps>) {
    const {
        state: { proposition, updatedProposition },
      
      } = useAppState();

    const navigate = useNavigate();

    const isBeneficiaryGuaranty = proposition?.configuration?.canBeAddedBeneficiaries && proposition?.configuration?.hasOfferStep;

  return (
    <div>
        <div className="flex-grid bg-blanc shadow-noir p-md mb-lg recap-content">
            <div className="grid-flex wrapper-edition ">
                <h2 className="card-title bleu mb-sm">
                Mes coordonnées bancaires
                </h2>

                <ButtonModifyRecapInfo
                        isDisplayed={proposition && isPropositionInDraft(proposition) && (!isConfirmedContactProposition(proposition!) || !isBeneficiaryGuaranty)}
                        handleClick={ () => navigate({ pathname: modifyUrl, search: `?id=${proposition!.propositionId}`, }) }
                    />
            </div>  
            <div>
                <div className="form-row">          
                    <div className="form-group mw-100">
                        <RecapElement id='accountOwner' label='Nom du titulaire du compte' value={`${updatedProposition?.bankingHolder??''} `}  />
                    </div>
                </div>
                <div className='form-row'>
                    <div className="form-group mw-100">
                        <RecapElement id='iban' label='IBAN' value={`${updatedProposition?.iban?.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()??''} `} />
                    </div>
                </div>  
            </div>        
        </div>
    </div>
)}
